import React from 'react'
import './Footer.css'
import { useNavigate } from 'react-router-dom'

function Footer() {
  const navigate = useNavigate()

  return (
    <footer className="footer">
      <div className="footer-content">
        <nav className="footer-menu">
          <a href="#" className="footer-menu-item" onClick={(e) => {
            e.preventDefault()
            navigate('/studio-policies')
          }}>Studio Policies</a>
          <a href="#" className="footer-menu-item" onClick={(e) => {
            e.preventDefault()
            navigate('/algemene-voorwaarden')
          }}>Algemene Voorwaarden</a>
          <a href="#" className="footer-menu-item" onClick={(e) => {
            e.preventDefault()
            navigate('/privacy-cookies')
          }}>Privacy & Cookies</a>
          <a href="#" className="footer-menu-item" onClick={(e) => {
            e.preventDefault()
            navigate('/teambuildings')
          }}>Teambuildings | Workshops | Zaalverhuur</a>
        </nav>
      </div>
    </footer>
  )
}

export default Footer 